import { getContext } from "@src/client/context";
import { getShouldDisplay } from "./getShouldDisplay";
import { getDeliveryCountry } from "./getDeliveryCountry";
import { getAreDeliveryOptionsAvailable } from "./getAreDeliveryOptionsAvailable";

export const getDisplayDecision = async minorCountries => {
  const webContext = getContext().getWebContext();
  const { browseCountry, geoCountry, storeId } = webContext;

  if (!(await getShouldDisplay({ geoCountry, browseCountry }))) {
    return { shouldDisplay: false };
  }

  const resolvedDeliveryCountry = await getDeliveryCountry({
    geoCountry,
    minorCountries
  });

  if (resolvedDeliveryCountry === null) {
    return { shouldDisplay: false };
  }

  let deliveryOptionsAreAvailable;

  try {
    deliveryOptionsAreAvailable = await getAreDeliveryOptionsAvailable(
      resolvedDeliveryCountry,
      storeId
    );
  } catch (_) {
    return { shouldDisplay: false };
  }

  return {
    shouldDisplay: !deliveryOptionsAreAvailable,
    resolvedDeliveryCountry
  };
};
